import { noop } from 'lodash';
import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { IHandleRequestFn, IMainContextProps } from '../../../../types';

export type LegacyFunctionContextType = {
  handleRequest: IHandleRequestFn;
  addToast: IMainContextProps['addToast'];
  openPrivacyModal: (termsOfUsePdfUrl?: string) => void;
};
export const LegacyFunctionContext = createContext<LegacyFunctionContextType>({
  // eslint-disable-next-line
  // @ts-ignore
  handleRequest: () => Promise.resolve(null),
  addToast: noop,
  openPrivacyModal: noop,
});

export const useLegacyFunction = () => useContext(LegacyFunctionContext);

export const LegacyFunctionProvider: FC<PropsWithChildren<LegacyFunctionContextType>> = ({
  children,
  handleRequest,
  addToast,
  openPrivacyModal,
}) => {
  return (
    <LegacyFunctionContext.Provider
      value={{
        handleRequest,
        addToast,
        openPrivacyModal,
      }}
    >
      {children}
    </LegacyFunctionContext.Provider>
  );
};